export const localStorageItemExists = (key: string): boolean => {
  try {
    const flag = localStorage.getItem(key);
    return !!flag;
  } catch (error) {
    return false;
  }
};
